import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import carouselTheme from '../styles/carouselTheme';
var SliderDotsContainer = styled.div.withConfig({
  displayName: "SliderDotsContainer",
  componentId: "zvridx-0"
})(["display:flex;list-style:none;margin:0;padding:0 ", ";position:absolute;text-align:center;", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (_ref) {
  var theme = _ref.theme,
      dotsType = _ref.dotsType;
  return rem(_get(theme, "carousel.dots.size[" + dotsType + "]", carouselTheme.carousel.dots.size[dotsType]));
}, function (_ref2) {
  var dotsPosition = _ref2.dotsPosition,
      dotsOrientation = _ref2.dotsOrientation;
  return dotsPosition === 'inside top' && dotsOrientation !== 'vertical' && css(["top:", ";"], function (_ref3) {
    var theme = _ref3.theme,
        dotsType = _ref3.dotsType;
    return rem(_get(theme, "carousel.dots.size[" + dotsType + "]", carouselTheme.carousel.dots.size[dotsType]) * 2);
  });
}, function (_ref4) {
  var dotsPosition = _ref4.dotsPosition,
      dotsOrientation = _ref4.dotsOrientation;
  return dotsPosition === 'inside bottom' && dotsOrientation !== 'vertical' && css(["bottom:", ";"], function (_ref5) {
    var theme = _ref5.theme,
        dotsType = _ref5.dotsType;
    return rem(_get(theme, "carousel.dots.size[" + dotsType + "]", carouselTheme.carousel.dots.size[dotsType]) * 2);
  });
}, function (_ref6) {
  var dotsPosition = _ref6.dotsPosition,
      dotsOrientation = _ref6.dotsOrientation;
  return dotsPosition === 'outside bottom' && dotsOrientation !== 'vertical' && css(["bottom:-", ";"], function (_ref7) {
    var theme = _ref7.theme,
        dotsType = _ref7.dotsType;
    return rem(_get(theme, "carousel.dots.size[" + dotsType + "]", carouselTheme.carousel.dots.size[dotsType]) * 2.8);
  });
}, function (_ref8) {
  var dotsPosition = _ref8.dotsPosition,
      dotsOrientation = _ref8.dotsOrientation;
  return dotsPosition === 'outside top' && dotsOrientation !== 'vertical' && css(["top:-", ";"], function (_ref9) {
    var theme = _ref9.theme,
        dotsType = _ref9.dotsType;
    return rem(_get(theme, "carousel.dots.size[" + dotsType + "]", carouselTheme.carousel.dots.size[dotsType]) * 2.8);
  });
}, function (_ref10) {
  var dotsAlignment = _ref10.dotsAlignment;
  return dotsAlignment === 'start' && css(["justify-content:flex-start;align-items:flex-start;"]);
}, function (_ref11) {
  var dotsAlignment = _ref11.dotsAlignment;
  return dotsAlignment === 'end' && css(["justify-content:flex-end;align-items:flex-end;"]);
}, function (_ref12) {
  var dotsAlignment = _ref12.dotsAlignment;
  return dotsAlignment === 'center' && css(["justify-content:center;align-items:center;"]);
}, function (_ref13) {
  var dotsOrientation = _ref13.dotsOrientation;
  return dotsOrientation === 'horizontal' && css(["margin:0;width:100%;"]);
}, function (_ref14) {
  var dotsOrientation = _ref14.dotsOrientation;
  return dotsOrientation === 'vertical' && css(["bottom:0;height:100%;width:", ";right:0;padding:", ";"], rem(50), function (_ref15) {
    var theme = _ref15.theme,
        dotsType = _ref15.dotsType;
    return rem(_get(theme, "carousel.dots.size[" + dotsType + "]", carouselTheme.carousel.dots.size[dotsType]));
  });
});
export default SliderDotsContainer;